import { Field } from "formik";
import { FormControl, Checkbox, FormHelperText } from "@chakra-ui/react";

export const CheckboxField = ({name, children, isRequired, helperMessage}) => {
	return (
		<Field as="checkbox" isRequired={isRequired} name={name}>
      {({ field, form }) => (
        <FormControl isInvalid={form.errors[name] && form.touched[name]} mb="0.5em">
          <Checkbox {...field} alignItems="baseline" colorScheme="red" isChecked={field.value}>
						{children}
					</Checkbox>
					{helperMessage && (<FormHelperText mt="5px" color="blackAlpha.600" fontSize="0.8em" ml="2em">{helperMessage}</FormHelperText>)}
        </FormControl>
      )}
    </Field>
	);
};